import { SearchIcon } from "@heroicons/react/outline";

function Buscador({Filter}) {
  return (
    <div className="relative rounded-md p-3 mt-0 xl:ml-10 sm:mt-5 md:mt-5 mb-3">
      <div className="cursor-pointer absolute inset-y-0 flex items-center pl-3">
        <SearchIcon className="h-5 w-5 text-red-500 hover:text-gray-200" />
      </div>
      <input
        className="block w-full rounded-md border-red-500 bg-transparent 
              pl-10 text-white focus:border-red-600
              focus:ring-red-600 sm:text-sm focus:outline-none focus:scale-105"
        type="text"
        id="myInput"
        onKeyUp={Filter}
        title="Search a Track"
        placeholder="Search Dj or Track"
      />
    </div>
  );
}

export default Buscador;
